import {Position} from 'cytoscape';
import React from 'react';
import {useLsValue} from '../../../../../hooks/use-ls-value';
import {GraphViewKind, QueryGraphLayoutAlgorithm} from '../../../../../components/graph/interface';
import {LS_PREFIX} from '../../../../../providers/global-state';
import {GraphPresentation, GraphPresentationDetails} from './interface';

interface Props {
    queryId: number;
    maxPathLength: number;
    viewKind: GraphViewKind;
    layoutAlgorithm: QueryGraphLayoutAlgorithm;
    selectedPresentation: GraphPresentation;
    selectedPresentationDetails: GraphPresentationDetails;
}

export const defaultPan = {x: 0, y: 0};
export const defaultZoom = '0.1';

export function useCameraProps(props: Props) {
    const [pan, setPan, clearPan] = useLsValue<string, [number, number], []>({
        rewriteKeyParams: [],
        changeEntityParams: [props.queryId, props.selectedPresentation.id],
        getKey: ([qId, pId]) => `${LS_PREFIX}.queryGraph.${qId}.presentation${pId}.pan`,
        defaultValue: JSON.stringify(defaultPan),
        validateValue: (val) => !Number.isNaN(JSON.parse(val).x) && !Number.isNaN(JSON.parse(val).y)
    });

    const [zoom, setZoom, clearZoom] = useLsValue<string, [number, number], []>({
        rewriteKeyParams: [],
        changeEntityParams: [props.queryId, props.selectedPresentation.id],
        getKey: ([qId, pId]) => `${LS_PREFIX}.queryGraph.${qId}.presentation${pId}.zoom`,
        defaultValue: defaultZoom,
        validateValue: (val) => !Number.isNaN(val) && Number(val) <= 1 && Number(val) >= 0
    });

    return {
        pan: JSON.parse(pan) as Position,
        setPan: React.useCallback((val: Position) => setPan(JSON.stringify(val)), [setPan]),
        clearPan,
        zoom: Number(zoom),
        setZoom: React.useCallback((val: number) => setZoom(String(val)), [setZoom]),
        clearZoom
    };
}
